import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";

import { eventOccurrenceAsMemberQueryKeys } from "./eventOccurrenceAsMemberQueryKeys";

export const useInfiniteQueryEventRsvpUpcomingAsMember = ({
  api,
  filters,
  enabled,
}: {
  api: ApiType;
  filters: Parameters<
    ApiType["customerOccurrenceApi"]["eventRsvpUpcoming"]
  >[0]["filters"];
  enabled: boolean;
}) =>
  useInfiniteQuery({
    queryKey: eventOccurrenceAsMemberQueryKeys.eventRsvpUpcoming(filters),
    queryFn: async ({ pageParam }: { pageParam?: string }) => {
      return (
        await api.customerOccurrenceApi.eventRsvpUpcoming({
          filters: {
            ...filters,
            nextPageToken: pageParam,
          },
        })
      ).data;
    },
    getNextPageParam: (lastPage) => lastPage.nextPageToken,
    initialPageParam: undefined,
    enabled,
  });
